import { View, Text } from 'dripsy';
import * as React from 'react';
export const Circle = React.forwardRef(({ backgroundColor = 'currentColor', color = 'background', children, size, ...props }, ref) => (React.createElement(View, { sx: {
        backgroundColor,
        borderRadius: 'full',
        justifyContent: 'center',
        alignItems: 'center',
        width: size,
        height: size,
    }, ref: ref, accessibilityRole: "image", ...props }, !!children && (React.createElement(Text, { sx: {
        fontSize: '$1',
        fontWeight: 'bold',
        textAlign: 'center',
        color,
    } }, children)))));
Circle.displayName = 'Circle';
//# sourceMappingURL=Circle.js.map